import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";

/* Replace empty strings with your Firebase web app credentials. */
export const firebaseConfig = {
  apiKey: "AIzaSyCXgZXwgdZ9WzvInNyOW-kj7bBHocK9yYM",
  authDomain: "vetcarez.firebaseapp.com",
  projectId: "vetcarez",
  storageBucket: "vetcarez.firebasestorage.app",
  messagingSenderId: "107034678496",
  appId: "1:107034678496:web:02aa1fd66c336956622c85",
  measurementId: "G-0F5SMGQVJ4"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// Force connection to emulators if running locally
if (typeof window !== 'undefined' && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")) {
  // Note: These ports must match your firebase.json (defaults are 9099, 8080, 9199)
  connectAuthEmulator(auth, "http://127.0.0.1:9099");
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
}

export { app, db, storage, auth };
